var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "button",
    {
      class: { box1: _vm.isactive, box2: !_vm.isactive },
      attrs: { value: "this.currentValue", disabled: _vm.disabled },
      on: { click: _vm.previousStep },
    },
    [
      _c(
        "div",
        { class: { texttitle1: _vm.isactive, texttitle2: !_vm.isactive } },
        [_vm._v("\n    " + _vm._s(_vm.buttontext) + "\n  ")]
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }